module.exports = __webpack_public_path__ + "img/2017-03-27.84bf103d.jpg";